import UserMenuConstants from "./UserMenuConstants";
export var getUserMenuItems = function (navigate) {
    var userMenuitems = UserMenuConstants();
    var items = [
        {
            label: userMenuitems.home,
            icon: "pi pi-home",
            visible: false,
            command: function () { return navigate("/user/dashboard"); },
        },
        {
            label: userMenuitems.status.list,
            icon: "pi pi-list",
            visible: false,
            command: function () { return navigate("/user/status"); },
        },
        {
            label: userMenuitems.admin.declarationstatistics,
            icon: "pi pi-chart-scatter",
            visible: true,
            command: function () { return navigate("/user/declaration-statistics"); },
        },
        {
            label: userMenuitems.address.list,
            icon: "pi pi-address-book",
            visible: false,
            command: function () { return navigate("/user/address/list"); },
        },
        {
            label: userMenuitems.options.types,
            icon: "pi pi-cog",
            visible: false,
            command: function () { return navigate("/user/options"); },
        },
        {
            label: userMenuitems.messages.heading,
            icon: "pi pi-comments",
            expanded: true,
            visible: false,
            items: [
                {
                    label: userMenuitems.messages.lodgepurchase.heading,
                    icon: "pi pi-envelope",
                    visible: false,
                    items: [
                        {
                            label: userMenuitems.messages.lodgepurchase.list,
                            icon: "pi pi-inbox",
                            visible: false,
                            command: function () { return navigate("/user/messages/lodgepurchase/list"); },
                        },
                        {
                            label: userMenuitems.messages.lodgepurchase.new,
                            icon: "pi pi-send",
                            visible: false,
                            command: function () { return navigate("/user/messages/lodgepurchase/new"); },
                        },
                        {
                            label: userMenuitems.messages.lodgepurchase.old,
                            icon: "pi pi-send",
                            visible: false,
                            command: function () { return navigate("/user/messages/lodgepurchase/old"); },
                        },
                    ],
                },
                {
                    label: userMenuitems.messages.akzs.heading,
                    icon: "pi pi-envelope",
                    visible: false,
                    items: [
                        {
                            label: userMenuitems.messages.akzs.list,
                            icon: "pi pi-inbox",
                            visible: false,
                            command: function () { return navigate("/user/messages/akzs/list"); },
                        },
                        {
                            label: userMenuitems.messages.akzs.new,
                            icon: "pi pi-send",
                            visible: false,
                            command: function () { return navigate("/user/messages/akzs/new"); },
                        },
                    ],
                },
                {
                    label: userMenuitems.messages.requestPurchaseIds.heading,
                    icon: "pi pi-envelope",
                    visible: false,
                    items: [
                        {
                            label: userMenuitems.messages.requestPurchaseIds.list,
                            icon: "pi pi-inbox",
                            visible: false,
                            command: function () { return navigate("/user/messages/requestPurchaseIds/list"); },
                        },
                        {
                            label: userMenuitems.messages.requestPurchaseIds.new,
                            icon: "pi pi-send",
                            visible: false,
                            command: function () { return navigate("/user/messages/requestPurchaseIds/new"); },
                        },
                    ],
                },
            ],
        },
        {
            label: userMenuitems.messages.receive.heading,
            icon: "pi pi-comments",
            expanded: true,
            visible: false,
            items: [
                {
                    label: userMenuitems.messages.receive.purchaseprocessids.heading,
                    icon: "pi pi-envelope",
                    visible: false,
                    items: [
                        {
                            label: userMenuitems.messages.receive.purchaseprocessids.list,
                            icon: "pi pi-inbox",
                            visible: false,
                            command: function () {
                                return navigate("/user/messages/receive/purchaseprocessids/list");
                            },
                        },
                    ],
                },
                {
                    label: userMenuitems.messages.receive.akzs.heading,
                    icon: "pi pi-envelope",
                    visible: false,
                    items: [
                        {
                            label: userMenuitems.messages.receive.akzs.list,
                            icon: "pi pi-inbox",
                            visible: false,
                            command: function () { return navigate("/user/messages/receive/akzs/list"); },
                        },
                    ],
                },
                {
                    label: userMenuitems.messages.receive.processpurchaseresult.heading,
                    icon: "pi pi-envelope",
                    visible: false,
                    items: [
                        {
                            label: userMenuitems.messages.receive.processpurchaseresult.list,
                            icon: "pi pi-inbox",
                            visible: false,
                            command: function () {
                                return navigate("/user/messages/receive/processpurchaseresult/list");
                            },
                        },
                    ],
                },
                {
                    label: userMenuitems.messages.receive.error.heading,
                    icon: "pi pi-envelope",
                    visible: false,
                    items: [
                        {
                            label: userMenuitems.messages.receive.error.list,
                            icon: "pi pi-inbox",
                            visible: false,
                            command: function () {
                                return navigate("/user/messages/receive/processerror/list");
                            },
                        },
                    ],
                },
            ],
        },
        {
            label: userMenuitems.log.list,
            icon: "pi pi-book",
            visible: false,
            command: function () { return navigate("/user/log"); },
        },
    ];
    return items;
};
